const styles = {
  boxWidth: "xl:max-w-[1280px] w-full",

  heading2: "font-poppins font-semibold xs:text-[48px] text-[40px] text-white xs:leading-[76.8px] leading-[66.8px] w-full",
  paragraph: "font-poppins font-normal text-dimWhite text-[18px] leading-[30.8px]",

  flexCenter: "flex justify-center items-center",
  flexStart: "flex justify-center items-start",

  paddingX: "md:px-16 sm:px-16 px-5",
  paddingY: "sm:py-16 py-6",
  padding: "md:px-0 sm:px-16 px-5 sm:py-12 py-4",
  paddingZ: "md:px-0 sm:px-16 px-5 md:py-4 sm:py-12 py-4",
  padding1: "md:px-0 sm:px-10 px-5",
  padding2: "md:px-0 sm:py-12 py-4",
  padding3: "md:px-0 sm:px-16 px-5 sm:pt-12 sm:pb-6 py-4",

  marginX: "sm:mx-16 mx-5",
  marginY: "sm:my-16 my-6",
};

export const layout = {
  section: `flex md:flex-row flex-col ${styles.paddingY}`,
  sectionReverse: `flex md:flex-row flex-col-reverse ${styles.paddingY}`,

  sectionImgReverse: `flex-1 flex ${styles.flexCenter} md:mr-10 mr-0 md:mt-0 mt-10 relative`,
  sectionImg: `flex-1 flex ${styles.flexCenter} md:ml-10 ml-0 md:mt-0 mt-10 relative`,

  sectionInfo: `flex-1 ${styles.flexStart} flex-col`,
};

export default styles;